<template>
  <div class="video_container" :class="{ normal: !fullScreen }">
    <div class="full_screen_video" v-if="visible" @click="togglePlay">
      <!-- 返回 -->
      <p v-if="fullScreen" class="back">
        <i @click="backFn"
          ><cl-svg-icon
            style="color: #fff"
            width="20"
            iconClass="back_white"
          ></cl-svg-icon
        ></i>
        <span @click="backFn">{{ title }}</span>
        <!-- 打开视频列表icon -->
        <img
          v-if="videoList.length > 1 && !showVideoList"
          class="video_shrink"
          src="@i/common/video_shrink_close.svg"
          alt
          @click="showVideoList = true"
        />
      </p>
      <video
        ref="video_player"
        class="video-js vjs-big-play-centered video_box"
        @play="onPlayerPlay()"
        @timeupdate="onTimeUpdate()"
        @pause="onPlayerPause()"
        @ended="onPlayerEnded()"
        @loadedmetadata="onLoadedmetadata($event)"
        playsinline
      ></video>
      <img
        v-show="drawingUrl"
        :style="imgStyle"
        :src="drawingUrl"
        class="drawing"
      />
      <!-- 右侧视频列表 -->
      <div
        v-if="download && showVideoList && videoList.length > 1"
        class="video_list"
      >
        <h2 class="video_list_title SysFontM">{{ $t("schedule.数据列表") }}</h2>
        <ul>
          <li
            v-for="(item, index) in videoList"
            :key="index"
            class="video_item"
            :class="{ active: index === currentVideoIndex }"
          >
            <div class="video_img" @click.stop="playVideo(item, index)">
              <img
                class="snapshot"
                :src="
                  item.snapshot && !item.imgError
                    ? item.snapshot
                    : defaultSnapshot
                "
                @error="item.imgError = true"
                alt="snapshot"
              />
              <span class="total_time" v-if="item.end && item.start">{{
                $utils.formatTime1(item.end - item.start)
              }}</span>
            </div>
            <div class="clip_info" @click.stop="playVideo(item, index)">
              <div class="clip_label">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top-start"
                  :content="item.label || item.name || ''"
                >
                  <div class="text_over">
                    {{
                      (item.remark ? item.remark : item.label || item.name) ||
                      ""
                    }}
                  </div>
                </el-tooltip>
              </div>
              <div class="clip_date">
                {{ $utils.formatTime("YYYY/MM/DD HH:mm", item.createTime) }}
              </div>
            </div>
          </li>
        </ul>
        <img
          class="open_img"
          src="@i/common/video_shrink_open.svg"
          alt
          @click="showVideoList = false"
        />
      </div>
      <div class="video_control_right">
        <div class="el_select mr16">
          <span @click="speedDialog = !speedDialog">{{ playSpeed + "X" }}</span>
          <div class="tooltip" v-show="speedDialog">
            <span
              @click="changePlaySpeed(item)"
              v-for="item in speedOptions"
              :key="item"
              :class="{ active: playSpeed == item }"
              >{{ item + "X" }}</span
            >
          </div>
        </div>
        <span
          class="video_volume mr16"
          @mouseenter="changeVolumeBar('show')"
          @mouseleave="changeVolumeBar('hide')"
        >
          <cl-svg-icon
            v-if="volumeValue === 0"
            :current-color="false"
            iconClass="icon_video_mute"
            width="20"
            @click.native="volumeChange(100)"
          ></cl-svg-icon>
          <cl-svg-icon
            v-else
            :current-color="false"
            iconClass="icon_video_volume"
            width="20"
            @click.native="volumeChange(0)"
          ></cl-svg-icon>
          <el-slider
            :class="['video_volume_slider', { hover: isShowVolumeBar }]"
            v-model="volumeValue"
            vertical
            height="80px"
            :max="1"
            :step="0.01"
            @input="volumeChange"
            :format-tooltip="formatTooltip"
          ></el-slider>
        </span>
        <!-- <span @click="downloadVideo">
          <cl-svg-icon
            v-if="
              download &&
              videoList[currentVideoIndex] &&
              !videoList[currentVideoIndex].notDowload
            "
            :current-color="false"
            width="16"
            iconClass="icon_download"
          ></cl-svg-icon>
        </span> -->
        <span v-if="normalMode" @click="fullScreenVideo">
          <cl-svg-icon
            :current-color="false"
            class="ml24"
            width="16"
            icon-class="full_screen"
          ></cl-svg-icon>
        </span>
      </div>
      <footer>
        <!-- 视频控制器 -->
        <div class="video_control">
          <p class="disp_ac">
            <cl-svg-icon
              v-if="!isStart"
              width="16"
              height="20"
              class="mr24"
              style="padding-left: 4px"
              iconClass="icon_video_start"
              @click.native="startAndStop('start')"
            ></cl-svg-icon>
            <cl-svg-icon
              v-else
              width="20"
              iconClass="icon_video_stop"
              class="mr24"
              @click.native="startAndStop('stop')"
            ></cl-svg-icon>
            <cl-svg-icon
              width="18"
              height="20"
              class="mr20"
              iconClass="icon_video_next"
              @click.native="playVideo()"
            ></cl-svg-icon>
          </p>
          <span class="video_time">
            {{ videoCurrentTime | formatTime }}
          </span>
        </div>
        <!-- 视频总时间 -->
        <span class="video_end_time">
          {{ videoTotalTime | formatTime }}
        </span>
        <div
          class="layer"
          v-show="speedDialog"
          @click="speedDialog = false"
        ></div>
      </footer>
    </div>
  </div>
</template>

<script>
/**
 * ComponentName: 视频短片
 * Created Date:2022/4/26
 * Author: shishuo·zhang
 * Modify:
 * 组件说明：
 * eg:
 *     <cl-video-clips></cl-video-clips>
 */
export default {
  name: "cl-video-clips", // 视频全屏播放带短片列表
  props: {
    // 控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否支持下载
    download: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: "",
    },
    // 当前的视频列表
    videoList: {
      type: Array,
      default: () => [],
    },
    // 当前的视频的index下标
    videoIndex: {
      type: Number,
      default: 0,
    },
    // 视频类型, 默认为全屏播放
    videoType: {
      type: String,
      default: "full_screen",
    },
  },
  data() {
    return {
      playSpeed: 1, // 视频播放速度
      speedOptions: [2.0, 1.5, 1.25, 1.0, 0.5], // 播放速度选项
      videoCurrentTime: 0, // 视频当前时间
      videoTotalTime: 0, // 视频总时长
      isStart: false, // 是否开始
      volumeValue: 0.3, // 音量初始值(0-1)
      isShowVolumeBar: false, // 是否显示音量控制条
      showVideoList: false, // 是否显示视频列表
      currentVideoIndex: 0, // 当前播放的视频下标
      currentVideoId: "", // 当前播放的视频Id
      videoPlayer: null, // 当前视频播放器
      speedDialog: false, // 控制快进倍率弹出框
      defaultSnapshot: require("@i/schedule/matchReport/default_snapshot.svg"), // 默认缩略图
      fullScreen: this.videoType === "full_screen", // 是否是全屏

      clipData: {}, // 短片数据
      drawingUrl: "", // 回显图片url
      clipModle: "normal", // 短片播放模式
      delayTime: 1000, // 延迟时间基础是1s
      imgStyle: {}, // 画图回显宽高
    };
  },
  watch: {
    visible(newVal) {
      this.$nextTick(() => {
        newVal && this.initVideoJS();
        if (this.$refs.video_player) {
          this.imgStyle = {
            width: this.$refs.video_player.offsetWidth + "px",
            height: this.$refs.video_player.offsetHeight + "px",
          };
        }
      });
    },
    currentVideoIndex(newVal) {
      this.$emit("change-video-index", newVal);
    },
    // 监听当前视频播放时间
    videoCurrentTime(newVal, oldVal) {
      this.drawingUrl = "";
      if (this.clipData) {
        // 回显绘图数据
        // console.log('cloudUrl',this.clipData)
        if (this.clipData.id && this.clipData.drawings) {
          this.clipData.drawings.forEach((draw) => {
            let { time, svg, json, cloudUrl, delay } = draw;
            time = time - this.clipData.start;
            if (
              oldVal !== time &&
              (Math.round(newVal) === Math.round(time) ||
                parseInt(newVal) === parseInt(time)) &&
              Math.abs(parseInt(newVal * 10) - parseInt(time * 10)) <= 2
            ) {
              this.videoPlayer.pause();
              this.videoPlayer.currentTime(time + 0.1);
              // 有json的为新版fabric.js画图数据
              // 有svg的为旧版svg.js画图数据
              if ((svg && svg.length) || json) {
                this.drawingUrl = cloudUrl;
                if (delay) {
                  // 设置了延迟播放时间
                  // 有画图数据时, 视频先暂停, 延迟时间过了之后继续播放
                  this.timer = setTimeout(() => {
                    // 2s后继续播放
                    this.startAndStop("start");
                  }, this.delayTime * delay);
                }
              } else {
                this.videoPlayer.play();
              }
            }
          });
        }
      }
    },
  },
  filters: {
    formatTime(result) {
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      if (h === "00") {
        return m + ":" + s;
      } else {
        return h + ":" + m + ":" + s;
      }
    },
  },
  computed: {
    // 是否是正常模式下的视频播放
    normalMode() {
      let boolean = this.videoType === "normal";
      return boolean;
    },
  },
  methods: {
    // 返回
    backFn() {
      if (this.videoType === "full_screen") {
        this.$emit("update:visible", false);
      } else {
        this.fullScreen = false;
      }
      this.$emit("close");
    },
    // 初始化视频
    initVideoJS(src) {
      if (src) {
        // 有视频播放的路径
        let that = this;
        this.videoPlayer.src(
          {
            type:
              src.indexOf(".m3u8") > 0 ? "application/x-mpegURL" : "video/mp4",
            src,
          },
          { type: "video/webm", src },
          { type: "video/mov", src }
        );
        this.videoPlayer.load(); // 使video重新加载
        this.videoPlayer.play(); // 加载完成后播放
        this.videoPlayer.ready(function () {
          this.playbackRate(that.playSpeed);
        });
      } else {
        // 第一次播放视频
        let index = this.videoIndex || 0;
        let item = this.videoList[index];
        this.clipData = item;
        this.currentVideoIndex = index;
        this.currentVideoId = item.url;
        let ele = this.$refs.video_player;
        // video.js初始化实例化的对象
        this.videoPlayer = this.$video(ele, {
          controls: true, // 是否显示控制条
          preload: "auto", // 是否预加载视频数据
          muted: false, // 是否静音
          language: "zh-CN", // 设置语言
          autoplay: !this.normalMode, // 自动播放, 正常模式下不进行自动播放
          sources: [
            // 视频源
            {
              type:
                item.url.indexOf(".m3u8") > 0
                  ? "application/x-mpegURL"
                  : "video/mp4",
              src: item.url,
            },
            {
              type: "video/webm",
              src: item.url,
            },
            {
              type: "video/mov",
              src: item.url,
            },
          ],
          controlBar: {
            // 设置控制条组件
            children: [
              { name: "progressControl" }, // 播放进度条
              // { name: 'fullscreenToggle' }     // 全屏按钮
            ],
          },
        });
        this.onPlayerPause();
      }
    },
    // 开始视频
    onPlayerPlay() {
      this.isStart = true;
    },
    // 实时更新
    onTimeUpdate() {
      this.videoCurrentTime = this.videoPlayer
        ? this.videoPlayer.currentTime()
        : 0;
    },
    // 暂停视频
    onPlayerPause() {
      this.isStart = false;
    },
    // 视频结束
    onPlayerEnded() {
      // 在播放列表中找到当前的视频修改isPlay属性为true
      let item = this.videoList.find(
        (i, index) => index === this.currentVideoIndex
      );
      item.isPlay = true;
      let findItem = this.videoList.find((i) => !i.isPlay); // 找到未播放的视频
      let findIndex = this.videoList.findIndex((i) => !i.isPlay);
      // console.log('onPlayerEnded', item, findItem, findIndex);
      if (findItem) {
        this.currentVideoIndex = findIndex;
        this.clipData = findItem;
        this.currentVideoId = item.url;
        this.initVideoJS(findItem.url);
      }
    },
    // 加载视频源数据
    onLoadedmetadata() {
      this.videoTotalTime = parseInt(this.videoPlayer.duration()) || 0;
    },
    // 开始或暂停视频
    startAndStop(type) {
      if (type === "start") {
        this.videoPlayer.play();
      } else {
        this.videoPlayer.pause();
      }
    },
    // 改变音量条是否显示
    changeVolumeBar(type) {
      let boolean = type === "show" ? true : false;
      this.isShowVolumeBar = boolean;
    },
    // 改变视频音量
    volumeChange(volume) {
      this.volumeValue = volume || 0;
      this.videoPlayer && this.videoPlayer.volume(this.volumeValue);
    },
    // 格式化信息
    formatTooltip() {
      return (parseInt(this.volumeValue * 100) || 0) + "%";
    },
    // 播放视频
    playVideo(item, index) {
      this.drawingUrl = "";
      // 在正常模式播放下, 不可重复点击当前视频
      if (this.normalMode && item && this.currentVideoId === item.url) {
        return;
      }
      if (item) {
        this.currentVideoIndex = index;
        this.clipData = item;
        this.currentVideoId = item.url;
        this.initVideoJS(item.url);
      } else {
        this.currentVideoIndex = ++this.currentVideoIndex;
        if (this.currentVideoIndex > this.videoList.length - 1) {
          this.currentVideoIndex = 0;
        }
        this.currentVideoId = this.videoList[this.currentVideoIndex].id;
        this.clipData = this.videoList[this.currentVideoIndex];
        this.initVideoJS(this.videoList[this.currentVideoIndex].url);
      }
    },
    // 下载视频
    downloadVideo() {
      // 635266285d547f00011e005b
      let item = this.videoList[this.currentVideoIndex];
      // console.log(item.url)
      // let url = `${this.$baseUrl.REQUEST_URL}/video/clip/download?clipId=${item.url}`;
      let params = {
        clipId: item.url,
      };
      // 下载前先检查短片是否存在
      this.$server.getDownloadClip(params).then((res) => {
        if (res && res.code === 200 && res.data) {
          // return;
          window.location.href = item.url;
        } else {
          this.$message.warning(this.$t("message.文件不存在"));
        }
      });
    },
    // 改变视频播放速度
    changePlaySpeed(item) {
      // https://stackoverflow.com/questions/19112255/change-the-video-playback-speed-using-video-js;
      this.playSpeed = item;
      this.speedDialog = false;
      this.videoPlayer.ready(function () {
        this.playbackRate(item);
      });
    },
    // 进入/退出 全屏视频
    fullScreenVideo() {
      this.fullScreen = !this.fullScreen;
    },

    // 播放、暂停视频
    togglePlay() {
      this.drawingUrl = "";
      if (this.isStart) {
        this.startAndStop("stop");
      } else {
        this.startAndStop("start");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video_container {
  // 默认视频样式
  &.normal {
    width: 100%;
    height: 100%;
    .full_screen_video {
      width: 100%;
      height: 100%;
      position: relative;
      padding: 8px;
      .video_list,
      .video_shrink {
        display: none;
      }
      .video_control_right {
        bottom: 5px;
        right: 14px;
      }
      footer {
        height: 78px;
        bottom: 0;
        .video_control {
          padding: 0;
          bottom: 0;
          top: 13px;
          > p {
            > svg {
              width: 20px !important;
              height: 16px !important;
              margin-right: 10px;
              color: #dce0df;
            }
          }
          .video_time {
            line-height: 20px;
          }
        }
        .video_end_time {
          bottom: 0;
          right: 22px;
          top: 13px;
        }
      }
    }
    /deep/ {
      .vjs-control-bar {
        width: calc(100% - 185px);
        left: 120px;
        bottom: 32px;
      }
    }
  }
}
::v-deep .layout_main_page {
  position: relative;
}
::v-deep {
  // 视频style
  .video_box {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
    video {
      object-fit: fill;
    }
  }
  .vjs-tech {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .video-js {
    position: relative;
    .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
      opacity: 1 !important;
    }
    .vjs-control-bar {
      width: calc(100% - 231px);
      left: 165px;
      bottom: 42px;
      background-color: transparent;
      z-index: 13;
    }
    .vjs-play-progress {
      background: #38cb89;
      &:before {
        color: #38cb89;
        background: rgba(#38cb89, 0.3);
        border-radius: 50%;
      }
    }
    .vjs-slider {
      background-color: rgba(255, 255, 255, 0.36);
    }
  }
}

.drawing {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  margin: 78px 24px 24px;
  top: 0;
  left: 0;
  border-radius: 4px;
}

.disp_ac {
  display: flex;
  align-items: center;
}

/* 文字超出部分设置为... */
.text_over {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.full_screen_video {
  box-sizing: border-box;
  padding: 78px 24px 24px;
  background-color: #16161a;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  color: #fff;
  font-family: "PingFang SC";
  z-index: 100;

  .back {
    position: absolute;
    z-index: 2;
    top: 24px;
    left: 24px;
    width: 100%;
    height: 54px;
    box-sizing: border-box;
    font-size: 22px;
    display: flex;
    align-items: center;
    color: #fff;
    cursor: pointer;
    .video_shrink {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 45px;
      margin-left: -40px;
      left: 50%;
      cursor: pointer;
      z-index: 88;
      transform: rotate(90deg);
    }
  }
  .video_end_time {
    bottom: 40px;
    position: absolute;
    right: 70px;
    font-family: AkrobatRegular;
    font-size: 16px;
    line-height: 30px;
    color: #f3f3f3;
  }
  .video_control_right {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 30px;
    right: 90px;
    z-index: 999;
    .video_volume {
      height: 40px;
      width: 20px;
      position: relative;
      display: flex;
      align-items: center;
      .video_volume_slider {
        display: none;
        position: absolute;
        right: -5px;
        top: -100px;
        padding-top: 5px;
        background-color: rgba(0, 0, 0, 0.9);
        height: 100px;
        border-radius: 6px;
        &.hover {
          display: inline-block;
        }
        ::v-deep {
          .el-slider__runway {
            width: 3px;
            margin: 8px 12px;
            background-color: #fff;
          }

          .el-slider__bar {
            width: 4px;
            background-color: #38cb89;
          }
          .el-slider__button {
            width: 12px;
            height: 12px;
            border: 1px solid rgba(255, 255, 255, 0.6);
            background-color: #fff;
          }
          .el-slider__button-wrapper {
            left: -16px;
          }
        }
      }
    }
    .el_select {
      position: relative;
      & > span {
        cursor: pointer;
        display: inline-block;
        width: 40px;
        text-align: center;
        font-size: 18px;
        font-family: AkrobatRegular;
      }
      .tooltip {
        position: absolute;
        z-index: 3;
        height: 150px;
        width: 60px;
        background: rgba(#000000, 0.9);
        border-radius: 6px;
        bottom: 28px;
        left: -14px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        line-height: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        span {
          margin-bottom: 8px;
          font-family: AkrobatRegular;
          cursor: pointer;
          &.active {
            color: #38cb89;
          }
        }
      }
    }
  }
  .video_control {
    position: absolute;
    left: 0;
    z-index: 5;
    bottom: 42px;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;

    .video_time {
      font-family: AkrobatRegular;
      font-size: 16px;
      line-height: 30px;
      color: #f3f3f3;
    }

    p {
      .svg_icon {
        width: 30px;
        height: 30px;
        margin-right: 30px;
        opacity: 0.6;
      }
    }
  }

  .video_list {
    position: absolute;
    width: 100%;
    top: 74px;
    left: 0;
    background: #16161a;
    color: #fff;
    padding: 16px 24px;
    box-sizing: border-box;
    z-index: 9999;
    .video_list_title {
      font-size: 16px;
      line-height: 30px;
      color: rgba(255, 255, 255, 0.8);
    }
    // transition: all 200ms;
    p {
      font-family: "PingFang SC";
      font-size: 22px;
      line-height: 30px;
      color: #fff;
      padding: 40px 0 28px 16px;
    }

    .open_img {
      position: absolute;
      bottom: -22px;
      transform: translateX(-50%) rotate(90deg);
      left: 50%;
      cursor: pointer;
      z-index: 11;
    }

    ul {
      width: 100%;
      overflow-x: auto;
      padding-top: 20px;
      box-sizing: border-box;
      display: flex;
      .video_item {
        position: relative;
        width: 142px;
        box-sizing: border-box;
        cursor: pointer;

        &:hover,
        &.active {
          .clip_info {
            .clip_label {
              color: #00cd8d;
            }
          }

          .download {
            display: block;
          }
        }

        .video_img {
          width: 114px;
          height: 64px;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 10px;
          img.snapshot {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }

          img.playing {
            width: 10px;
            height: 10px;
            position: absolute;
            left: 8px;
            bottom: 8px;
          }

          .total_time {
            font-family: AkrobatRegular;
            height: 20px;
            position: absolute;
            right: 6px;
            bottom: 0px;
            font-size: 12px;
            line-height: 20px;
            color: rgb(255, 255, 255);
          }
        }

        .clip_info {
          width: 142px;
          box-sizing: border-box;
          font-size: 12px;
          color: $base-font-minor;
          position: relative;

          .clip_label {
            font-family: SysFontM;
            color: rgba(255, 255, 255, 1);
            line-height: 23px;
            margin-bottom: 4px;
            font-size: 14px;
            letter-spacing: 0.015em;
          }

          .clip_date {
            font-family: AkrobatRegular;
            line-height: 15px;
            font-size: 12px;
            color: #81818a;
          }
        }

        .download {
          width: 16px;
          height: 16px;
          display: none;
          position: absolute;
          right: 12px;
          bottom: 40px;
          color: #75d267;
        }
      }
    }
  }
  footer {
    width: 100%;
    height: 64px;
    background: linear-gradient(
      180deg,
      rgba(22, 22, 26, 0) 0%,
      rgba(22, 22, 26, 0.8) 100%
    );
    position: absolute;
    bottom: 24px;
    z-index: 3;
  }
  .layer {
    position: fixed;
    height: 100%;
    width: 100%;
    background: transparent;
    left: 0;
    top: 0;
    z-index: 2;
  }
}
</style>
